const config = {
    linkedInUrl: "https://www.linkedin.com/in/harini-s-995684248/",
    githubUrl: "https://github.com/HariniS1018",
    emailAddress: "hariniks0618@gmail.com",
    cvPath: "/Harini-S-CV.pdf",
};

export default config;